import { useState } from 'react'

import Router from 'next/router'
import styled from 'styled-components'

import { useDetectMobileDeviceOS, useBodyScrollLock } from 'hooks'

import { Button } from 'components/v2/Button'
import { Column } from 'components/v2/Grid'
import Image from 'next/image'
import { Text } from 'components/v2/Text'

import { VITTUDE_APP_STORE_LINK } from 'utils/constants'

export const DownloadAppCard = () => {
	const [isDownloadAppCardOpen, setIsDownloadAppCardOpen] = useState(true)

	const { deviceOS, isMobile } = useDetectMobileDeviceOS()
	const validacaoMobile = isMobile && isDownloadAppCardOpen

	useBodyScrollLock(validacaoMobile, [isMobile, isDownloadAppCardOpen])

	const handleDownloadAppClick = () => {
		Router.push(VITTUDE_APP_STORE_LINK[deviceOS])
		setIsDownloadAppCardOpen(false)
	}

	return (
		<>
			{isMobile && isDownloadAppCardOpen && (
				<>
					<Container id='DownloadAppCard'>
						<VittudeAppLogo src='/static/images/app/vittude-app.webp' />
						<Text className='mb-6 text-base font-semibold leading-6 tracking-[0.15px]'>
							Baixe o app da Vittude para gerenciar sua agenda e fazer seus
							agendamentos mais rápidos
						</Text>
						<Column className='w-full gap-2'>
							<Button
								variant='primary'
								className='flex h-14 w-full items-center justify-center gap-2 rounded-[10px] text-sm font-semibold'
								onClick={handleDownloadAppClick}
							>
								Instalar aplicativo
								<Image
									src='/static/images/icon-download.svg'
									width={24}
									height={24}
								/>
							</Button>
							<Button
								variant='primary-outlined'
								className='h-14 w-full rounded-[10px] border-[#E7EAF4] text-sm font-semibold text-gray-800'
								onClick={() => setIsDownloadAppCardOpen(false)}
							>
								Agora não
							</Button>
						</Column>
					</Container>
					<Overlay onClick={() => setIsDownloadAppCardOpen(false)} />
				</>
			)}
		</>
	)
}

const Container = styled(Column)`
	background-color: white;
	z-index: 100;
	position: fixed;
	bottom: 0;
	width: 100%;
	border-top-left-radius: 25px;
	border-top-right-radius: 25px;
	padding: 24px;
	padding-top: 40px;
	text-align: center;
	align-items: center;
`

const VittudeAppLogo = styled.img`
	width: 64px;
	height: 64px;
	border-radius: 10px;
	margin-bottom: 8px;
	margin-top: -72px;
`

const Overlay = styled.div`
	width: 100%;
	height: 100%;
	top: 0;
	z-index: 90;
	background: #00000045;
	position: fixed;
`
